import { trpc } from "@util/trpc/trpcClient";
import { throttle } from "lodash";
import { Duration } from "luxon";
import { useEffect, useMemo } from "react";

const THROTTLED_TIMEOUT = Duration.fromObject({ minutes: 5 });
const ACTIVITY_EVENTS = [
  "mousemove",
  "keydown",
  "touchstart",
  "wheel",
  "click",
];

const useRefreshTokenTTLOnActivityHandler = () => {
  const { mutate: refreshTokenTTL } = trpc.users.refreshTokenTTL.useMutation();

  const throttledRefresher = useMemo(() => {
    return throttle(
      () => {
        refreshTokenTTL();
      },
      THROTTLED_TIMEOUT.as("milliseconds"),
      { leading: true, trailing: false },
    );
  }, [refreshTokenTTL]);

  useEffect(() => {
    for (const event of ACTIVITY_EVENTS) {
      window.addEventListener(event, throttledRefresher);
    }

    return () => {
      for (const event of ACTIVITY_EVENTS) {
        window.removeEventListener(event, throttledRefresher);
      }
      throttledRefresher.cancel();
    };
  }, [throttledRefresher]);
};

export default useRefreshTokenTTLOnActivityHandler;
